"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PageHeader = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _core = require("@emotion/core");

var _emotionTheming = require("emotion-theming");

var _stencilReactDesc = require("@amzn/stencil-react-desc");

var _styledWithTheme = require("../../context/styledWithTheme");

var _useResizeObserver2 = require("../../hooks/useResizeObserver");

var _layout = require("../../layout");

var _useAppLayout2 = require("../../layout/app-layout/useAppLayout");

var _propTypes = require("../../prop-types");

var _utils = require("../../utils");

var _PageContainer = require("../PageContainer");

var _PageHeaderContext = require("./PageHeaderContext");

var _constants = require("./constants");

var _interfaces = require("./interfaces");

var _excluded = ["colorScheme", "children", "isFullWidth", "hasShadow", "hasBottomBorder", "isFixed", "top", "aria-label"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var HeaderRow = (0, _styledWithTheme.styledWithTheme)(_layout.View.withComponent('header', {
  target: "emwj0d80"
}))(function (_ref) {
  var colorScheme = _ref.colorScheme,
      hasShadow = _ref.hasShadow,
      isFixed = _ref.isFixed,
      hasTopComponent = _ref.hasTopComponent,
      hasBottomBorder = _ref.hasBottomBorder,
      selectors = _ref.theme.selectors,
      top = _ref.top;
  var borderColor = selectors.color(colorScheme === _interfaces.PageHeaderColorScheme.Inverted ? 'neutral20' : 'neutral70');
  var styles = {
    alignItems: 'center',
    backgroundColor: selectors.color(colorScheme === _interfaces.PageHeaderColorScheme.Inverted ? 'neutral0' : 'neutral90'),
    boxShadow: hasShadow ? "0px 0px 10px ".concat((0, _utils.opacify)(selectors.color('neutral90'), 0.2)) : 'none',
    display: 'inline-block',
    height: hasTopComponent ? undefined : selectors.constant('headerHeight'),
    left: 0,
    minWidth: isFixed ? '100dvw' : '100%',
    borderBottom: hasBottomBorder ? "1px solid ".concat(borderColor) : undefined,
    top: top
  };
  return isFixed ? _objectSpread(_objectSpread({}, styles), {}, {
    position: 'fixed',
    zIndex: selectors.zIndex('header')
  }) : styles;
});

var PageHeaderBase = function PageHeaderBase(props) {
  var _useAppLayout = (0, _useAppLayout2.useAppLayout)(),
      settings = _useAppLayout.settings,
      isInAppLayout = _useAppLayout.isInAppLayout;

  var hasTopComponent = !!settings.topLayoutComponent;

  var _ref2 = isInAppLayout ? _objectSpread(_objectSpread({}, props), settings.pageHeaderProps) : props,
      _ref2$colorScheme = _ref2.colorScheme,
      colorScheme = _ref2$colorScheme === void 0 ? _interfaces.PageHeaderColorScheme.Default : _ref2$colorScheme,
      children = _ref2.children,
      _ref2$isFullWidth = _ref2.isFullWidth,
      isFullWidth = _ref2$isFullWidth === void 0 ? _constants.PageHeaderDefaultProps.isFullWidth : _ref2$isFullWidth,
      _ref2$hasShadow = _ref2.hasShadow,
      hasShadow = _ref2$hasShadow === void 0 ? _constants.PageHeaderDefaultProps.hasShadow : _ref2$hasShadow,
      _ref2$hasBottomBorder = _ref2.hasBottomBorder,
      hasBottomBorder = _ref2$hasBottomBorder === void 0 ? _constants.PageHeaderDefaultProps.hasBottomBorder : _ref2$hasBottomBorder,
      _ref2$isFixed = _ref2.isFixed,
      isFixed = _ref2$isFixed === void 0 ? _constants.PageHeaderDefaultProps.isFixed : _ref2$isFixed,
      _ref2$top = _ref2.top,
      top = _ref2$top === void 0 ? _constants.PageHeaderDefaultProps.top : _ref2$top,
      ariaLabel = _ref2['aria-label'],
      forwardedProps = (0, _objectWithoutProperties2.default)(_ref2, _excluded);

  var _useTheme = (0, _emotionTheming.useTheme)(),
      selectors = _useTheme.selectors;

  var _useResizeObserver = (0, _useResizeObserver2.useResizeObserver)(),
      ref = _useResizeObserver.ref,
      height = _useResizeObserver.height;

  var defaultHeaderHeight = selectors.constant('headerHeight');
  var hasResizeObserver = isInAppLayout && !!settings.topLayoutComponent;
  var dynamicHeaderHeight = hasResizeObserver ? height : defaultHeaderHeight;
  return (0, _core.jsx)(_layout.View, {
    margin: {
      top: top
    }
  }, (0, _core.jsx)(HeaderRow, (0, _extends2.default)({}, (0, _utils.pickDataProps)(forwardedProps), {
    ref: hasResizeObserver ? ref : undefined,
    colorScheme: colorScheme,
    hasShadow: hasShadow,
    isFixed: isFixed,
    top: top,
    "aria-label": ariaLabel,
    hasTopComponent: hasTopComponent,
    hasBottomBorder: hasBottomBorder || isInAppLayout
  }), settings.topLayoutComponent, isInAppLayout && isFixed && (0, _core.jsx)(_core.Global, {
    styles: {
      'main *[id]': {
        scrollMarginTop: dynamicHeaderHeight + selectors.space('S300')
      }
    }
  }), (0, _core.jsx)(_PageContainer.PageContainer, {
    paddingBottom: "S250",
    paddingTop: "S250",
    display: "flex",
    height: hasTopComponent ? defaultHeaderHeight : '100%',
    alignItems: "center",
    isFullWidth: isFullWidth
  }, (0, _core.jsx)(_PageHeaderContext.PageHeaderContext.Provider, {
    value: {
      colorScheme: colorScheme
    }
  }, children))), isFixed && (0, _core.jsx)(_layout.Spacer, {
    height: dynamicHeaderHeight
  }));
};

var PageHeaderWithDocs = (0, _stencilReactDesc.describe)(PageHeaderBase).description('Page header with base functionality.');
PageHeaderWithDocs.propTypes = {
  colorScheme: _stencilReactDesc.PropTypes.oneOf(Object.values(_interfaces.PageHeaderColorScheme)).description('Selects a predefined color scheme to use for the component.'),
  top: (0, _propTypes.cssValue)().description('Sets the spacing from the top, especially useful when "isFixed" is true.'),
  hasShadow: _stencilReactDesc.PropTypes.bool.description('Determines whether to render a shadow.'),
  hasBottomBorder: _stencilReactDesc.PropTypes.bool.description('Determines if the component has a bottom border. This is always active if the component is in an AppLayout.'),
  isFixed: _stencilReactDesc.PropTypes.bool.description('Determines whether to fix the header to the top of the page.'),
  isFullWidth: _stencilReactDesc.PropTypes.bool.description("Determines whether to ignore theme's maxWidth and apply full width."),
  'aria-label': _stencilReactDesc.PropTypes.string.description("'aria-label' is applied to the <header> element. It is announced by screen readers.")
};
var PageHeader = (0, _utils.withTestAttributes)({
  component: 'StencilReactPageHeader'
})(PageHeaderWithDocs);
exports.PageHeader = PageHeader;
PageHeader.defaultProps = _objectSpread({}, _constants.PageHeaderDefaultProps);
PageHeader.displayName = 'PageHeader';